import type { Component } from 'vue';
import { MicrositeSocialLinkPlatform } from '@web/enums/MicrositeSocialLinkPlatform';
import FacebookLogoRegular from '@web/components/utilities/svg/phosphorIcons/FacebookLogoRegular.vue';
import InstagramLogoRegular from '@web/components/utilities/svg/phosphorIcons/InstagramLogoRegular.vue';
import YoutubeLogoRegular from '@web/components/utilities/svg/phosphorIcons/YoutubeLogoRegular.vue';
import XLogoRegular from '@web/components/utilities/svg/phosphorIcons/XLogoRegular.vue';
import TiktokLogoRegular from '@web/components/utilities/svg/phosphorIcons/TiktokLogoRegular.vue';
import SpotifyLogoRegular from '@web/components/utilities/svg/phosphorIcons/SpotifyLogoRegular.vue';
import ApplePodcastsLogoRegular from '@web/components/utilities/svg/phosphorIcons/ApplePodcastsLogoRegular.vue';
import GlobeRegular from '@web/components/utilities/svg/phosphorIcons/GlobeRegular.vue';
import EnvelopeRegular from '@web/components/utilities/svg/phosphorIcons/EnvelopeRegular.vue';
import { MicrositeSocialLinkValueType } from '@web/enums/MicrositeSocialLinkValueType';

export type MicrositeSocialLinkOption = {
  platform: MicrositeSocialLinkPlatform;
  valueType: MicrositeSocialLinkValueType;
  icon: Component;
  title: string;
  placeholder: string;
};

export function getMicrositeSocialLinkOptions(): MicrositeSocialLinkOption[] {
  return [
    {
      platform: MicrositeSocialLinkPlatform.FACEBOOK,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: FacebookLogoRegular,
      title: 'Facebook',
      placeholder: 'https://facebook.com/yourpage',
    },
    {
      platform: MicrositeSocialLinkPlatform.INSTAGRAM,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: InstagramLogoRegular,
      title: 'Instagram',
      placeholder: 'https://instagram.com/yourusername',
    },
    {
      platform: MicrositeSocialLinkPlatform.YOUTUBE,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: YoutubeLogoRegular,
      title: 'YouTube',
      placeholder: 'https://youtube.com/@yourusername',
    },
    {
      platform: MicrositeSocialLinkPlatform.X,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: XLogoRegular,
      title: 'X (formerly Twitter)',
      placeholder: 'https://x.com/yourusername',
    },
    {
      platform: MicrositeSocialLinkPlatform.TIKTOK,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: TiktokLogoRegular,
      title: 'TikTok',
      placeholder: 'https://tiktok.com/@yourusername',
    },
    {
      platform: MicrositeSocialLinkPlatform.SPOTIFY,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: SpotifyLogoRegular,
      title: 'Spotify',
      placeholder: 'https://open.spotify.com/show/123456789',
    },
    {
      platform: MicrositeSocialLinkPlatform.APPLE_PODCASTS,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: ApplePodcastsLogoRegular,
      title: 'Apple Podcasts',
      placeholder:
        'https://podcasts.apple.com/us/podcast/yourpodcast/123456789',
    },
    {
      platform: MicrositeSocialLinkPlatform.WEBSITE,
      valueType: MicrositeSocialLinkValueType.URL,
      icon: GlobeRegular,
      title: 'Website',
      placeholder: 'https://yourwebsite.com',
    },
    {
      platform: MicrositeSocialLinkPlatform.EMAIL,
      valueType: MicrositeSocialLinkValueType.EMAIL,
      icon: EnvelopeRegular,
      title: 'Email',
      placeholder: 'connect@yourwebsite.com',
    },
  ];
}

export function getMicrositeSocialLinkOption(
  platform: MicrositeSocialLinkPlatform,
): MicrositeSocialLinkOption {
  const micrositeSocialLinkOption = getMicrositeSocialLinkOptions().find(
    (option) => option.platform === platform,
  );

  if (micrositeSocialLinkOption === undefined) {
    throw new Error('Invalid platform: ' + platform);
  }

  return micrositeSocialLinkOption;
}
